import React, { MouseEvent, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

const AccessibilityRouteSupport = () => {
  const location = useLocation();
  const announcementRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const timer = window.setTimeout(() => {
      if (announcementRef.current) {
        const pageName = document.title.replace(/\s*-\s*Nclude Portal\s*$/i, "");
        announcementRef.current.textContent = `${pageName || "Page"} loaded`;
      }
    }, 0);
    return () => window.clearTimeout(timer);
  }, [location.pathname]);

  const skipToMain = (event: MouseEvent<HTMLAnchorElement>) => {
    const main = document.querySelector<HTMLElement>("main, [role='main']");
    if (!main) return;
    event.preventDefault();
    if (!main.hasAttribute("tabindex")) main.setAttribute("tabindex", "-1");
    main.focus();
    main.scrollIntoView({ block: "start" });
  };

  return (
    <>
      <a className="skip-link" href="#main-content" onClick={skipToMain}>
        Skip to main content
      </a>
      <div ref={announcementRef} className="visually-hidden" role="status" aria-live="polite" aria-atomic="true" />
    </>
  );
};

export default AccessibilityRouteSupport;
